import { Attribute, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

@JsonApiModelConfig({
    type: 'tipos-de-configuracao'
})
export class TipoDeConfiguracao extends JsonApiModel {
    @Attribute() defaultt: any
    @Attribute() clazz: string
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/configuracao/tipo-de-configuracao.model.ts